import React, { createContext } from 'react';
import { useAddDataForm } from 'hooks/useAddDataForm';

const DeleteStorageDataContext = createContext();

function DeleteStorageDataProvider({
	children,
	data = {
		name: '',
		share: null,
		submitted: false,
	},
}) {
	const { inputs, change } = useAddDataForm(data);

	return (
		<DeleteStorageDataContext.Provider value={{ inputs, change }}>
			{children}
		</DeleteStorageDataContext.Provider>
	);
}

export { DeleteStorageDataContext, DeleteStorageDataProvider };
